export const mapConfig = {
  container: "map",
  center: [ 5.291266, 52.132633 ],
  maxBounds: [ 2.35, 49.35, 11.63, 53.89 ],
  zoom: 8,

  // Needed for exporting the map to SVG and PNG. For performance reasons do not enable in normal map.
  preserveDrawingBuffer: true,

  // RouteStack offers two different map styles: basic and bright.
  // The style will also load the RouteStack tileset that holds all OSM related data.
  style: "https://cdn.routestack.com/styles/basic/style.json"
};

export const fitBoundsConfig = {
  padding: 40,
  duration: 2000,
};